class inputTaxTypeCtrl {
    constructor($scope, httpRequest, logger, sweetalert) {
        $scope.listData = []
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 1000,
            param: {},
        }
        $scope.queryList1 = function queryList() {
            httpRequest.get_getIvatRuleConfList({
                ruleType: 'zclx',
            }).then((res) => {
                $scope.listData1 = res.data.value
                $scope.listData1Sub = $scope.listData1.splice(0, 5)
            })
        }
        // $scope.queryList2 = function queryList2() {
        //     httpRequest.get_getIvatRuleConfList({
        //         ruleType: 'dkbz',
        //     }).then((res) => {
        //         $scope.listData2 = res.data.value
        //         $scope.listData2Sub = $scope.listData2.splice(0, 2)
        //     })
        // }
        $scope.queryList3 = function queryList3() {
            httpRequest.get_getIvatRuleConfList({
                ruleType: 'rzfllx',
            }).then((res) => {
                $scope.listData3 = res.data.value
            })
        }
        $scope.queryList4 = function queryList4() {
            httpRequest.get_getIvatRuleConfList({
                ruleType: 'bxpzfl',
            }).then((res) => {
                getTaxItem(res.data.value)
            })
        }
        // type: zclx
        // type: dkbz
        // type: rzfllx
        $scope.add2 = function add2(ruleType, list) {
            list.unshift({
                ruleName: '',
                remark: '',
                editState: true,
                ruleType,
            })
        }
        $scope.add3 = function add2(ruleType, list) {
            list.push({
                ruleName: '',
                creditNo: '',
                debitNo: '',
                ruleDetail: '',
                editState: true,
                ruleType,
            })
        }
        $scope.save1 = function save1(con) {
            if (!con.ruleName) {
                logger.logError('转出类型不能为空')
                return
            }
            if (!con.ruleConfId) {
                httpRequest.post_addIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList1()
                })
            } else {
                httpRequest.post_updateIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList1()
                })
            }
        }

        $scope.delete2 = function delete2(con, index, list) {
            if (!con.ruleConfId) {
                list.splice(index, 1)
                return
            }
            sweetalert.confirm('删除提醒', '确定删除该配置？').then(() => {
                httpRequest.post_delIvatRuleConf(con.ruleConfId).then(() => {
                    list.splice(index, 1)
                    logger.logSuccess('删除成功')
                })
            })
        }
        $scope.save2 = function save2(con) {
            if (!con.ruleName) {
                logger.logError('配置规则名称不能为空')
                return
            }
            if (!con.ruleConfId) {
                httpRequest.post_addIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList2()
                })
            } else {
                httpRequest.post_updateIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList2()
                })
            }
        }
        $scope.save3 = function save3(con) {
            if (!con.ruleName) {
                logger.logError('入账分类配置')
                return
            }
            if (!con.ruleConfId) {
                httpRequest.post_addIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList3()
                })
            } else {
                httpRequest.post_updateIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList3()
                })
            }
        }
        $scope.save4 = function save4(con) {
            if (!con.ruleName) {
                logger.logError('请选择类型')
                return
            }
            if (!con.ruleDetail) {
                logger.logError('请选择明细')
                return
            }
            if (!con.debitNo) {
                logger.logError('请选择借方科目')
                return
            }
            if (!con.creditNo) {
                logger.logError('请选择贷方科目')
                return
            }

            if (!con.ruleConfId) {
                httpRequest.post_addIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList4()
                })
            } else {
                httpRequest.post_updateIvatRuleConf(con).then(() => {
                    logger.logSuccess('保存成功')
                    $scope.queryList4()
                })
            }
        }
        $scope.queryList1()
        // $scope.queryList2()
        $scope.queryList3()
        $scope.queryList4()

        //类型
        $scope.classify = [{
                enumName: '部门',
                enumCode: 'depart'
            },
            {
                enumName: '报销类型',
                enumCode: 'expense'
            }
        ]
        $scope.DicClassify = [{
                enumName: '全部',
                enumCode: 'all'
            },
            {
                enumName: '部门',
                enumCode: 'depart'
            },
            {
                enumName: '报销类型',
                enumCode: 'expense'
            }
        ]
        //获取部门
        function getDepartment() {
            let params = {
                pageNum: 0,
                pageSize: 10000,
                param: {}
            }
            httpRequest.post_qryDepartmentList(params).then((res) => {
                $scope.departmentList = res.data.value.list
                //与报销项目统一字段
                $scope.departmentList.forEach(item => {
                    item.confId = item.departmentId
                    item.expenseName = item.departmentName
                })
            })
        }
        $scope.ruleDetail = []
        //获取报销项目
        function getReimItem() {
            httpRequest.get_getIvatBxPzDTOList(false).then((res) => {
                $scope.ReimList = res.data.value
            })
        }

        //获取税务科目
        function getTaxItem(value) {
            let param = {
                pageNum: 1,
                pageSize: 10000,
                param: {
                    swkjkmDmAndSwkjkmmc: '',
                    accessToken: localStorage.getItem('id_token'),
                }
            }
            httpRequest.post_getSbSwkjkmDmList(param).then(res => {
                const ret = toSelect2data(res.data.value.list, 'swkjkmDm', 'swkjkmmc')
                $scope.taxpayerOptions3 = {
                    data: ret
                }
                $scope.taxpayerOptions3.placeholder = '请选择'
                value.forEach(item => {
                    item.s2item = []
                    item.s3item = []
                    ret.forEach(i => {
                        if (i.swkjkmDm == item.creditNo) {
                            item.s3item = i
                        }
                        if (i.swkjkmDm == item.debitNo) {
                            item.s2item = i
                        }
                    })
                })
                $scope.listData4 = value
            })
        }

        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: ''
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][idfield] + '/' + list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        getDepartment()
        getReimItem()

        $scope.classifyChange = function classifyChange(ruleName) {
            if (ruleName == 'depart') {
                $scope.ruleDetail = $scope.departmentList
            } else {
                $scope.ruleDetail = $scope.ReimList
            }
        }
        httpRequest.get_checkIvatRuleConf().then(res => {
            if (res.data.value) {
                logger.logTips(res.data.value, 'warn')
            }
        })
        $scope.selectChange = function selectChange(item) {
            if (item.ruleName == 'depart') {
                let departmentList = $scope.departmentList
                for (const val of departmentList) {
                    if (val.departmentId == item.ruleDetail) {
                        item.ruleDetailName = val.departmentName
                        break
                    }
                }
            } else if (item.ruleName == 'expense') {
                let ReimList = $scope.ReimList
                for (const val of ReimList) {
                    if (val.confId == item.ruleDetail) {
                        item.ruleDetailName = val.expenseName
                        break
                    }
                }
            }
        }
        $scope.handleChange = function handleChange(con, type) {
            let list = $scope.taxpayerOptions3.data
            for (const val of list) {
                if (con[type] == val.id) {
                    if (type == 'creditNo') {
                        con.creditName = val.swkjkmmc
                    } else if (type == 'debitNo') {
                        con.debitName = val.swkjkmmc
                    }
                    break
                }
            }
        }
        $scope.cancel = function (v) {
            switch (v) {
                case 1:
                    $scope.queryList1()
                    break;
                case 3:
                    $scope.queryList3()
                    break;
                case 4:
                    $scope.queryList4()
                    break;
                default:
                    break;
            }
        }
    }
}

inputTaxTypeCtrl.$inject = ['$scope', 'httpRequest', 'logger', 'sweetalert']

export default inputTaxTypeCtrl


// WEBPACK FOOTER //
// ./src/app/input/basedata/inputTaxType/inputTaxTypeCtrl.js